import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
import navigation from "../views/navigation.vue";
import quotedPrice from "../views/quotedPrice.vue";
import todayQuotedPrice from "../views/todayQuotedPrice.vue";
import todayQuotedPriceCopy from "../views/todayQuotedPriceCopy.vue";
import buyerCenter from "../views/buyerCenter.vue";
import test from "../views/test.vue";
import aboutUs from "../views/aboutUs.vue";
import issueProduct from "../views/issueProduct.vue";
import consult from "../views/consult.vue";
import consultDetails from "../views/consultDetails.vue";
import strictStore from "../views/strictStore.vue";
import concatMe from "../views/concatMe.vue";
import detailsPage from "../views/detailsPage.vue";
import storeHome from "../views/storeHome.vue";
import order from "../views/order.vue";
import chat from "../views/chat.vue";
import buyOrder from "../views/buyOrder.vue";
import play from "../views/play.vue";
import PriceTrend from "../views/PriceTrend.vue";

import historicalQuotation from "../views/historicalQuotation.vue";

import baiduMap from "../views/baiduMap.vue";

import dataPage from "../views/dataPage.vue";



Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		meta: "Q搜广场",
		name:'',
	    component: () => import('../views/squareSou.vue')
	},
	{
		path: "/ce2",
		meta: "Q搜广场",
		name:'',
	    component: () => import('../views/ce3.vue')
	},
		{
		path: "/materInformation",
		meta: "原料资讯",
		name:'materInformation',
	    component: () => import('../views/materInformation.vue')
	},{
		path: "/priceAll",
		meta: "报价大全",
		name:'priceAll',
	    component: () => import('../views/priceAll.vue')
	},
		{
		path: "/consultPageOwn",
		meta: "资讯",
		name:'consultPageOwn',
	    component: () => import('../views/consultPageOwn.vue')
	},
		{
		path: "/consultWeekPage",
		meta: "周报列表",
		name:'consultWeekPage',
	    component: () => import('../views/consultWeekPage.vue')
	},
	
		{
		path: "/forecastPage",
		meta: "行情预测",
		name:'forecastPage',
	    component: () => import('../views/forecastPage.vue')
	},
	
		{
		path: "/enterTitleDetails",
		meta: "企业资讯",
		name:'enterTitleDetails',
	    component: () => import('../views/enterTitleDetails.vue')
	},
	
	{
		path: "/store",
		name:'store',
		meta: "原材料",
		component: () => import('../views/store.vue')

	},
	{
		path: "/questPage",
		meta: "Q搜问答",
		component: () => import('../views/questPage.vue')
	},
	{
		path: "/ideaPage",
		meta: "Q搜想法",
		component: () => import('../views/ideaPage.vue')

	},
	{
		path: "/purchasePage",
		meta: "Q搜采购",
		component: () => import('../views/purchasePage.vue')


	},
	{
		path: "/disCountPage",
		meta: "Q搜特惠产品",
		component: () => import('../views/disCountPage.vue')

	},

	{
		path: "/consultPage",
		meta: "Q搜文章",
		component: () => import('../views/consultPage.vue')

	},
		{
			path: "/talkPage",
			name:'talkPage',
			meta: "Q搜话题",
			component: () => import('../views/talkPage.vue')


	},

	{
		path: "/circleDetail",
		meta: "Q搜商圈",
		component: () => import('../views/circleDetail.vue')

	},
	{
		path: "/singleCircle",
		meta: "Q搜商圈",
		component: () => import('../views/singleCircle.vue')
	},

	{
		path: "/search",
		name: "搜索",
		meta: "搜索",
		component: () => import('../views/luoSearch.vue')
	},
	{
		path: "/vudio",
		name: "视频",
		meta: "视频",
		component: () => import('../views/vudio')
		
	},
	{
		path: "/creatorPage",
		name: "创作者主页",
		meta: "创作者主页",
		component: () => import('../views/creatorPage')
		
	},
	{
		path: "/facturerPage",
		name: "厂商主页",
		meta: "厂商主页",
		component: () => import('../views/facturerPage')
		
	},

	{
		path: "/hotVideo",
		name: "视频",
		meta: "视频",
        component: () => import('../views/hotVideo')
		
	},
	{
		path: "/baiduMap",
		meta: "Q搜网",

		component: baiduMap
	},

	{
		path: "/PriceTrend",
		meta: "Q搜网",

		component: PriceTrend
	},
	{
		path: "/encyclopedia",
		meta: "Q搜网",

		component: () => import("../views/encyclopedia.vue")
	},
	{
		path: "/titleDetails",
		meta: "Q搜网",
		component: () => import('../views/titleDetails')
		
	},
	{
		path: "/titleDetailsCopy",
		meta: "Q搜网",

		component: () => import("../views/titleDetailsCopy.vue")
	},
	{
		path: "/ideaDetails",
		meta: "Q搜网",
		component: () => import("../views/ideaDetails.vue")
	},
	{
		path: "/questionDetails",
		meta: "Q搜网",
		component: () => import("../views/questionDetails.vue")
	},

	{
		path: "/storeDetails",
		meta: "Q搜网",
		component: () => import("../views/storeDetails.vue")
	},

	{
		path: "/encyclopediaDeilt",
		meta: "Q搜网",
		component: () => import("../views/encyclopediaDeilt.vue")
	},
	{
		path: "/message",
		meta: "Q搜网",
		component: () => import("../views/message.vue")
	},


	// {
	// 	path: "/login",
	// 	name: "登录",
	// 	component: login
	// },


	{
		path: "/navigation",
		meta: "Q搜网",
		component: () => import("../views/navigation.vue")

	},
	{
		path: "/quotedPrice",
		name: "行业行情",
		meta: "行业行情",
		component: () => import("../views/quotedPrice.vue")
	},
	{
		path: "/todayQuotedPrice",
		meta: "Q搜网",
		component: () => import("../views/todayQuotedPrice.vue")

	},
	{
		path: "/todayQuotedPriceCopy",
		meta: "Q搜网",
		component: () => import("../views/todayQuotedPriceCopy.vue")

	},

	{
		path: "/issueProduct",
		meta: "Q搜网",
		component: () => import("../views/issueProduct.vue")
	},
	{
		path: "/store",
		meta: "原材料报价",
		component: index
		
	},
	{
		path: "/consult",
		meta: "原材料资讯",
		component: () => import("@/views/consult.vue")
	},
	{
		path: "/consultDetails",
		meta: "资讯详情",
		component: () => import("@/views/consultDetails.vue")
	},
	{
		path: "/strictStore",
		meta: "严选商城",
		component: () => import("@/views/strictStore.vue")
	},
	{
		path: "/concatMe",
		name: "concatMe",
		component: () => import("@/views/concatMe.vue")
	},
	{
		path: "/detailsPage",
		meta: "商品详情",
		component: () => import("@/views/detailsPage.vue")
	},
	{
		path: "/storeHome",
		meta: "Q搜网",
		component: () => import("@/views/storeHome.vue")
	},
	{
		path: "/historicalQuotation",
		meta: "Q搜网",
		component: () => import("@/views/historicalQuotation.vue")
	},
	{
		path: "/order",
		meta: "Q搜网",
		component: () => import("@/views/order.vue")
	},
	{
		path: "/buyOrder",
		meta: "Q搜网",
		component: () => import("@/views/buyOrder.vue")
	},

	{
		path: "/buyerCenter",
		name: "buyerCenter",
		 component: () => import("../views/buyerCenter.vue"),

		redirect: "/message",
		children: [
			{
				path: "home",
				meta: "个人中心",
	            component: () => import("../views/home.vue")
			},
				{
				path: "theMessage",
				meta: "消息中心",
				component: () => import("../views/theMessage.vue")
			},
			{
				path: "message",
				meta: "买家中心",
				component: () => import("../views/message.vue")

			},
		
			{
				path: "theProduct",
				meta: "产品管理",
				component: () => import("../views/theProduct.vue")
		
			},
			{
				path: "myOrder",
				meta: "我的订单",
				component: () => import("../views/myOrder.vue")

			},
			{
				path: "myCollect",
				meta: "我的收藏",
				component: () => import("../views/myCollect.vue")

			},
			{
				path: "attention",
				meta: "关注的商家",
				component: () => import("../views/attention.vue")

			},
			{
				path: "personal",
				meta: "个人信息",
				component: () => import("../views/personal.vue")
			},
			{
				path: "enterpriseInfo",
				meta: "企业信息",
				component: () => import("../views/enterpriseInfo.vue")
				
			},
			{
				path: "address",
				meta: "地址管理",
				component: () => import("../views/address.vue")
			},
			{
				path: "amendPersonal",
				meta: "修改信息",
                 component: () => import("../views/amendPersonal.vue")
				
			},
			{
				path: "amendEnterpriseInfo",
				meta: "企业认证",
				component: () => import("../views/amendEnterpriseInfo.vue")
				
			},
			{
				path: "carts",
				meta: "购物车",
				component: () => import("../views/carts.vue")
			},
			{
				path: "afterSale",
				component: () => import("../views/afterSale.vue")
				
			},
			{
				path: "afterSalePut",
				component: () => import("../views/afterSalePut.vue")
				
			},
			{
				path: "orderInfo",
				component: () => import("../views/orderInfo.vue")
			},
			{
				path: "help",
				meta: "帮助管理",
                component: () => import("../views/help.vue"),
			},
			{
				path: "helpDetails",
				name: "帮助详情",
				component: () => import("../views/helpDetails.vue"),
			},
			{
				path: "systemNotice",
				meta: "系统公告推送",
				component: () => import("../views/systemNotice.vue"),
			},
			{
				path: "systemNoticeDetails",
				meta: "公告推送",
				component: () => import("../views/systemNoticeDetails.vue"),
			},
			{
				path: "suppliers",
				meta: "申请供应商",
				component: () => import("../views/suppliers.vue"),
			},
			{
				path: "application",
				meta: "厂商申请",
				component: () => import("../views/application.vue")
				
			},
			{
				path: "productPrice",
				meta: "产品报价",
				component: () => import("../views/productPrice.vue")
			},
			{
				path: "evaluate",
				component: () => import("../views/evaluate.vue")
		
			},
			{
				path: "publishVideo",
				component: () => import("../views/publishVideo.vue"),
				meta: "视频管理"
			},
			{
				path: "qwen",
				component: () => import("../views/qwen.vue"),
				meta: "Q文管理"
			},
			{
				path: "pushNewsCopy",
				component: () => import("../views/pushNewsCopy.vue"),
				meta: "资讯管理"
			},
			
			{
				path: "markForecastList",
				component: () => import("../views/markForecastList.vue"),
				meta: "行情预测"
			},
			{
				path: "ideaManage",
				component: () => import("../views/ideaManage.vue"),
				meta: "想法发布"
			},
			{
				path: "questionManage",
				component: () => import("../views/questionManage.vue"),
				meta: "问答管理"
			},
			{
				path: "specialProductManage",
				component: () => import("../views/specialProductManage.vue"),
				meta: "特惠产品"
			},
			{
				path: "circleManage",
				component: () => import("../views/circleManage.vue"),
				meta: "商圈管理"
			},
			{
				path: "demand",
				component: () => import("../views/demand.vue"),
				meta: "需求发布"
			},
			{
				path: "goodShowCase",
				component: () => import("../views/goodShowCase.vue"),
				meta: "好物橱窗"
			},

			{
				path: "integral",
				component: () => import("../views/integral.vue"),
				meta: "收益管理"
			},
			{
				path: "selectStore",
				component: () => import("../views/selectStore.vue"),
				meta: "严选商城订单"
			},
			{
				path: "withdrawal",
				component: () => import("../views/withdrawal.vue"),
				meta: "严选商城订单"
			},
			{
				path: "contribute",
				meta: "投稿",
				component: () => import("../views/contribute.vue"),

			},
			{
				path: "taskCenter",
				component: () => import("../views/taskCenter.vue"),
				meta: "任务中心"
			},
			{
				path: "dataPage",
				component: dataPage,
				meta: "数据页面"
			},
			{
				path: "priviLege",
				component: () => import("../views/priviLege.vue"),
				meta: "企业特权"
			},
			{
				path: "qyData",
				component: () => import("../views/qyData.vue"),
				meta: "企业信息"
			},
			{
				path: "commentManage",
				component: () => import("../views/commentManage.vue"),
				meta: "评论管理"
			},
			{
				path: "wxTry",
				component: () => import("../views/wxTry.vue"),
				name: "wxTry"
			},
			{
				path: "strictStoreAdmin",
				component: () => import("../views/strictStoreAdmin.vue"),
				meta: "严选商城"
			},
			{
				path: "corVip",
				component: () => import("../views/corVip.vue"),
				meta: "企业会员"
			},
			{
				path: "subManage",
				component: () => import("../views/subManage.vue"),
				meta: "订阅管理"
			},
			{
				path: "markForecast",
				component: () => import("../views/markForecast.vue"),
				meta: "行业预测"
			},
					{
				path: "accountManagement",
				component: () => import("../views/accountManagement.vue"),
				meta: "账号管理"
			},

			
			{
				path: "weekReport",
				component: () => import("../views/weekReport.vue"),
				meta: "周报"
			},
		
			{
				path: "monthReport",
				component: () => import("../views/monthReport.vue"),
				meta: "月报"
			}
		]
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

router.afterEach((to, from) => {

	document.title = to.meta;
});
router.beforeEach((to, from, next) => {
	console.log("ces");
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
	window.pageYOffset = 0;
	next();
});

export default router;
